import React from 'react';
import { Download, X, Smartphone, Zap, Shield, Heart } from 'lucide-react';
import { usePWA } from '../hooks/usePWA';

const PWAInstallPrompt: React.FC = () => {
  const { showInstallPrompt, installApp, dismissInstallPrompt } = usePWA();

  if (!showInstallPrompt) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:max-w-sm z-50">
      <div className="bg-white rounded-2xl shadow-2xl border border-orange-100 p-6 transform transition-all duration-300 animate-in slide-in-from-bottom">
        <div className="flex items-start justify-between mb-4">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-gradient-to-br from-teal-400 to-teal-500 rounded-xl flex items-center justify-center">
              <Heart className="w-6 h-6 text-white" />
            </div>
            <div>
              <h3 className="font-bold text-slate-900">Install Mira</h3>
              <p className="text-sm text-slate-600">Get the full app experience</p>
            </div>
          </div>
          <button
            onClick={dismissInstallPrompt}
            className="p-1 text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="space-y-3 mb-6">
          <div className="flex items-center gap-3 text-sm text-slate-700">
            <Smartphone className="w-4 h-4 text-teal-600" />
            <span>Works offline for journaling</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-700">
            <Zap className="w-4 h-4 text-orange-600" />
            <span>Faster loading and performance</span>
          </div>
          <div className="flex items-center gap-3 text-sm text-slate-700">
            <Shield className="w-4 h-4 text-purple-600" />
            <span>Push notifications for check-ins</span>
          </div>
        </div>

        <div className="flex gap-3">
          <button
            onClick={dismissInstallPrompt}
            className="flex-1 px-4 py-2 border border-slate-300 text-slate-700 rounded-xl hover:bg-slate-50 transition-colors"
          >
            Not now
          </button>
          <button
            onClick={installApp}
            className="flex-1 flex items-center justify-center gap-2 bg-gradient-to-r from-teal-500 to-teal-600 text-white px-4 py-2 rounded-xl hover:from-teal-600 hover:to-teal-700 transition-colors"
          >
            <Download className="w-4 h-4" />
            Install
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;